import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var google: any;

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (typeof google !== 'undefined' && google.maps) {
      return Promise.resolve();
    }
    if (!this.loadPromise) {
      this.loadPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        // Same libraries/language as the static <script> tag in index.html, so this
        // fallback (only ever exercised if that tag is ever removed) behaves identically.
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.apyKeyGoogleMaps}&libraries=visualization,places,geometry&language=es`;
        script.async = true;
        script.defer = true;
        script.onload = () => resolve();
        script.onerror = (err) => reject(err);
        document.head.appendChild(script);
      });
    }
    return this.loadPromise;
  }
}
